import LegalPage, { LSection, LList } from "../../components/legal/LegalPage";
import { LEGAL_IDENTITY, LEGAL_EMAIL } from "../../lib/legal";

export default function Privacy() {
  return (
    <LegalPage
      title="Política de privacidad"
      subtitle="Cómo trata Asset Passport los datos personales en el marco del piloto B2B."
      testid="privacy-page"
    >
      <LSection n="1" title="Responsable del tratamiento">
        <dl className="grid sm:grid-cols-[160px_1fr] gap-y-2 gap-x-4">
          <dt className="font-medium text-zinc-900">Responsable</dt>
          <dd>{LEGAL_IDENTITY.ownerName}</dd>
          <dt className="font-medium text-zinc-900">Nombre comercial</dt>
          <dd>{LEGAL_IDENTITY.commercialName}</dd>
          <dt className="font-medium text-zinc-900">País</dt>
          <dd>{LEGAL_IDENTITY.country}</dd>
          {LEGAL_EMAIL && (
            <>
              <dt className="font-medium text-zinc-900">Contacto privacidad</dt>
              <dd>
                <a href={`mailto:${LEGAL_EMAIL}`} className="underline underline-offset-2 hover:text-zinc-900">
                  {LEGAL_EMAIL}
                </a>
              </dd>
            </>
          )}
        </dl>
      </LSection>

      <LSection n="2" title="Ámbito de aplicación">
        <p>
          Esta política cubre los datos personales tratados a través de: el sitio web público de
          Asset Passport, las solicitudes de acceso al piloto, las cuentas de usuario, el acceso a
          la plataforma, las comunicaciones, los registros de seguridad y auditoría y las
          interacciones de soporte.
        </p>
        <p>
          Las organizaciones cliente pueden introducir datos personales en fichas de máquinas,
          documentos, fotografías o historiales de intervenciones. Para esos datos aportados por el
          cliente, este actúa generalmente como responsable del tratamiento y Asset Passport como
          encargado, conforme al Acuerdo de Encargo del Tratamiento (DPA) y a las instrucciones del
          cliente.
        </p>
      </LSection>

      <LSection n="3" title="Categorías de datos">
        <p className="font-medium text-zinc-900">Solicitudes de acceso al piloto</p>
        <LList
          items={[
            "nombre y apellidos",
            "empresa",
            "email profesional",
            "teléfono (opcional)",
            "mensaje (opcional)",
            "estado de la solicitud y fecha",
          ]}
        />
        <p className="font-medium text-zinc-900">Datos de cuenta</p>
        <LList
          items={[
            "nombre y apellidos",
            "email",
            "empresa y rol",
            "información de autenticación y seguridad",
            "estado de la verificación en dos pasos, cuando aplique",
          ]}
        />
        <p className="font-medium text-zinc-900">Datos de seguridad</p>
        <LList
          items={[
            "dirección IP",
            "eventos de autenticación",
            "eventos de auditoría",
            "registros técnicos y de seguridad relevantes",
          ]}
        />
        <p className="font-medium text-zinc-900">Contenido del cliente</p>
        <LList
          items={[
            "información de máquinas",
            "ubicaciones",
            "documentos",
            "fotografías",
            "registros de intervenciones",
            "nombres de los autores de intervenciones",
            "notas u otros contenidos subidos por usuarios autorizados",
          ]}
        />
        <p className="font-medium text-zinc-900">Comunicaciones</p>
        <p>Información facilitada voluntariamente al contactar con Asset Passport.</p>
      </LSection>

      <LSection n="4" title="Finalidades del tratamiento">
        <LList
          items={[
            "gestionar las solicitudes de acceso al piloto",
            "crear y administrar las organizaciones cliente",
            "autenticar a los usuarios",
            "prestar el servicio Asset Passport",
            "gestionar usuarios y permisos",
            "proteger la seguridad de la plataforma",
            "prevenir abusos y accesos no autorizados",
            "prestar soporte",
            "enviar comunicaciones transaccionales",
            "mantener los registros de auditoría necesarios",
            "cumplir obligaciones legales",
            "establecer, ejercer o defender reclamaciones legales, cuando proceda",
          ]}
        />
        <p>
          Asset Passport no utiliza actualmente los datos de los clientes con fines publicitarios.
          La analítica y la grabación de sesiones de PostHog se encuentran actualmente
          desactivadas, sin que ello implique un compromiso permanente.
        </p>
      </LSection>

      <LSection n="5" title="Bases jurídicas">
        <LList
          items={[
            "aplicación de medidas precontractuales solicitadas por el interesado (solicitudes de acceso al piloto)",
            "ejecución de la relación de servicio B2B",
            "interés legítimo en la seguridad de la plataforma, la prevención del fraude y la administración del servicio, cuando proceda",
            "cumplimiento de obligaciones legales",
            "consentimiento, únicamente cuando resulte genuinamente aplicable",
          ]}
        />
      </LSection>

      <LSection n="6" title="Plazos de conservación">
        <p>
          <span className="font-medium text-zinc-900">Solicitudes piloto:</span> se conservan
          mientras se evalúa la solicitud y durante un período razonable posterior para gestionar la
          relación y acreditar su tramitación, con sujeción a los requisitos legales aplicables.
        </p>
        <p>
          <span className="font-medium text-zinc-900">Cuentas y datos de clientes activos:</span>{" "}
          durante la vigencia de la relación de servicio.
        </p>
        <p>
          <span className="font-medium text-zinc-900">Información de seguridad y auditoría:</span>{" "}
          durante los períodos razonablemente necesarios para la seguridad, la rendición de cuentas
          y la defensa legal, con sujeción a las políticas de retención que se definan.
        </p>
        <p>
          <span className="font-medium text-zinc-900">Datos eliminados:</span> la información
          eliminada deja de ser accesible a través de la aplicación conforme a los mecanismos de
          borrado actuales. La eliminación técnica de los archivos en la infraestructura de
          almacenamiento subyacente puede estar sujeta a las capacidades del proveedor de
          almacenamiento y a los procesos de retención y seguridad aplicables.
        </p>
      </LSection>

      <LSection n="7" title="Destinatarios y proveedores de servicios">
        <p>
          Asset Passport utiliza proveedores tecnológicos necesarios para operar el servicio.
          Actualmente:
        </p>
        <LList
          items={[
            "Emergent — alojamiento de la aplicación, infraestructura y servicios gestionados",
            "Google Cloud — infraestructura cloud subyacente",
            "Cloudflare — entrega de red y seguridad",
            "AWS CloudFront — entrega de determinados activos de la plataforma",
            "Resend — email transaccional",
            "Google Fonts — recursos tipográficos, cuando aplique",
            "Unsplash — recursos de imagen, cuando aplique",
          ]}
        />
        <p>
          La infraestructura de analítica PostHog se encuentra actualmente desactivada y no recibe
          datos.
        </p>
      </LSection>

      <LSection n="8" title="Transferencias internacionales">
        <p>
          Algunos de los proveedores de servicios e infraestructura utilizados por Asset Passport
          están ubicados en Estados Unidos o pueden tratar datos en Estados Unidos.
        </p>
        <p>
          Cuando resulte aplicable, las transferencias internacionales de datos se articularán
          mediante los mecanismos reconocidos por la normativa de protección de datos aplicable,
          como decisiones de adecuación, cláusulas contractuales tipo u otras garantías válidas,
          según corresponda al proveedor y al tratamiento.
        </p>
      </LSection>

      <LSection n="9" title="Derechos de las personas interesadas">
        <p>Puedes ejercer los siguientes derechos:</p>
        <LList
          items={[
            "acceso",
            "rectificación",
            "supresión",
            "limitación del tratamiento",
            "oposición",
            "portabilidad, cuando proceda",
            "retirada del consentimiento, cuando el tratamiento se base en él",
          ]}
        />
        <p>
          Las solicitudes deben dirigirse al correo de contacto de privacidad configurado
          {LEGAL_EMAIL ? (
            <>
              {": "}
              <a href={`mailto:${LEGAL_EMAIL}`} className="underline underline-offset-2 hover:text-zinc-900">
                {LEGAL_EMAIL}
              </a>
            </>
          ) : (
            " por Asset Passport"
          )}
          . Cuando sea razonablemente necesario, podrá solicitarse verificación de identidad.
        </p>
        <p>
          También tienes derecho a presentar una reclamación ante la Agencia Española de Protección
          de Datos (AEPD).
        </p>
      </LSection>

      <LSection n="10" title="Seguridad">
        <p>
          Asset Passport aplica medidas técnicas y organizativas destinadas a proteger los datos
          personales de forma apropiada a los riesgos del servicio. Ningún sistema puede garantizar
          seguridad absoluta.
        </p>
      </LSection>

      <LSection n="11" title="Cambios en esta política">
        <p>
          Esta política puede actualizarse por cambios legales, técnicos o del servicio. Los cambios
          materiales se comunicarán de forma apropiada.
        </p>
      </LSection>
    </LegalPage>
  );
}
